import { gql } from '@apollo/client';

export const ConfirmSmartImportMutationName = 'ConfirmSmartImport';

export const CONFIRM_SMART_IMPORT_MUTATION = gql`
  mutation ${ConfirmSmartImportMutationName}(
    $id: ID!
    $overrides: SmartImportOverridesInput!
  ) {
    confirmSmartImport(id: $id, overrides: $overrides) {
      smartImport {
        id
        status
        startedAt
        overrides {
          global {
            siteId
          }
          rows {
            rowRef
            overrides {
              siteId
            }
          }
        }
        progress {
          processedRowCount
          totalRowCount
          currentChunk
          totalChunks
        }
        error {
          code
          message
        }
      }
    }
  }
`;
